
import { defaultWagmiConfig } from '@web3modal/wagmi/react/config';
import { arbitrum, arbitrumSepolia, Chain } from 'wagmi/chains';

const metadata = {
    name: 'tgether',
    description: 'AppKit Example',
    url: 'https://reown.com/appkit',
    icons: ['https://assets.reown.com/reown-profile-pic.png']
  };
const projectId= process.env.REACT_APP_WALLET_PROJECT_ID as string;

const chains: readonly [Chain, ...Chain[]] =
  process.env.REACT_APP_CHAIN_ID === "0xa4b1" ? [arbitrum] : [arbitrumSepolia];

export const config = defaultWagmiConfig({
  chains,
  projectId,
  metadata,
});
;